//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// responsive
import { M, T } from "../../utils/MT";

// img
import LogoSvg from "../../assets/img/icon/footer_logo.svg";
import InSvg from "../../assets/img/icon/in.svg";
import YoutubeSvg from "../../assets/img/icon/youtube.svg";
import FacebookSvg from "../../assets/img/icon/facebook.svg";
import InstaSvg from "../../assets/img/icon/insta.svg";
import TwitterSvg from "../../assets/img/icon/twitter.svg";

export default function Footer() {
    //페이지 이동
    const navigate = useNavigate();
    const goHome = () => {
        navigate(`/`);
    };
    // const goCartPage = () =>{
    //     navigate(`/cart`);
    // }
    const goLinkPage = () => {
        navigate(`/`);
    };

    // sns 링크 리스트
    const goLinkedinPage = () => {
        window.open("https://www.linkedin.com/company/fabweaver/", "_blank");
    };
    const goYoutubePage = () => {
        window.open("https://www.youtube.com/channel/UCqfMu_pKhc0rKjkojhvGJNA", "_blank");
    };
    const goFacebookPage = () => {
        window.open("https://www.facebook.com/fabWeaver.official", "_blank");
    };
    const goInstagramPage = () => {
        window.open("https://www.instagram.com/fabweaver/", "_blank");
    };
    const goTwitterPage = () => {
        window.open("https://twitter.com/fabweaver_3d", "_blank");
    };

    const utilListData = [
        {
            onClickEvent: goLinkPage,
            text: "3D Printers",
        },
        {
            onClickEvent: goLinkPage,
            text: "Filaments",
        },
        {
            onClickEvent: goLinkPage,
            text: "Supplies",
        },
        {
            onClickEvent: goLinkPage,
            text: "AS part",
        },
    ];

    const snsListData = [
        {
            onClickEvent: goLinkedinPage,
            iconImg: InSvg,
            alt: "Linkedin",
        },
        {
            onClickEvent: goYoutubePage,
            iconImg: YoutubeSvg,
            alt: "youtube",
        },
        {
            onClickEvent: goFacebookPage,
            iconImg: FacebookSvg,
            alt: "facebook",
        },
        {
            onClickEvent: goInstagramPage,
            iconImg: InstaSvg,
            alt: "instagram",
        },
        {
            onClickEvent: goTwitterPage,
            iconImg: TwitterSvg,
            alt: "twitter",
        },
    ];

    return (
        <Warp>
            <TopWrap>
                <InnerWrap>
                    <FooterLogo onClick={goHome} src={LogoSvg} alt="fabweaver" />
                    <UtilWrap>
                        {utilListData.map((list, index) => {
                            return (
                                <Util key={index} onClick={list.onClickEvent}>
                                    {list.text}
                                </Util>
                            );
                        })}
                    </UtilWrap>
                    <InfoBigWrap>
                        <InfoWrap>
                            <PC>
                                <Info>회사명 : (주)신도리코</Info>
                                <Info>대표자 : 박동안</Info>
                            </PC>
                            <Mobile>
                                <InfoMbWrap>
                                    <Info>회사명 : (주)신도리코</Info>
                                    <Info>대표자 : 박동안</Info>
                                </InfoMbWrap>
                            </Mobile>
                            <Info>사업자 등록번호 : 218-81-00328</Info>
                            <Info>전화 : 02-6010-5300</Info>
                        </InfoWrap>
                        <InfoWrap>
                            <Info>주소 : 서울특별시 성동구 성수이로 24길 3</Info>
                            <Info>통신판매신고번호 : 2017-서울성동구- 0779</Info>
                            <Info>이메일주소 : info@fabweaver.com</Info>
                        </InfoWrap>
                    </InfoBigWrap>
                </InnerWrap>
            </TopWrap>
            <BottomWrap>
                <InnerWrap>
                    <LeftCon>
                        <CopyRight>&copy; fabWeaver 2022</CopyRight>
                        <TermsWrap>
                            <Terms>TERMS OF USE</Terms>
                            <Terms>PRIVACY POLICY</Terms>
                        </TermsWrap>
                    </LeftCon>
                    <RightCon>
                        <SnsTitle>Contact with :</SnsTitle>
                        <SnsWrap>
                            {snsListData.map((item, index) => {
                                return (
                                    <Sns key={index}>
                                        <SnsImg onClick={item.onClickEvent} src={item.iconImg} alt={item.alt} />
                                    </Sns>
                                );
                            })}
                        </SnsWrap>
                    </RightCon>
                </InnerWrap>
            </BottomWrap>
        </Warp>
    );
}

const Warp = styled.footer`
    position: relative;
    width: 100%;
`;

const TopWrap = styled.section`
    padding: calc(100vw * (40 / 1920)) 0;
    background: #111111;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (40 / 1300)) 0;
    }
    @media screen and (max-width: 900px) {
        padding: ${M(40)} 0 ${M(30)};
    }
`;

const InnerWrap = styled.div`
    width: calc(100vw * (1160 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1160 / 1300));
    }
    @media screen and (max-width: 900px) {
        width: ${M(378)};
    }
`;

const FooterLogo = styled.img`
    width: calc(100vw * (152 / 1920));
    height: calc(100vw * (18 / 1920));
    margin-bottom: calc(100vw * (40 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (152 / 1300));
        height: calc(100vw * (18 / 1300));
        margin-bottom: calc(100vw * (18 / 1300));
    }
    @media screen and (max-width: 900px) {
        width: ${M(152)};
        height: ${M(18)};
        margin-bottom: ${M(30)};
    }
`;

const UtilWrap = styled.ul`
    display: flex;
    align-items: center;

    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (20 / 1300));
    }
    @media screen and (max-width: 900px) {
        margin-bottom: ${M(30)};
    }
`;

const Util = styled.li`
    font: calc(100vw * (14 / 1920)) "Pop-SB";
    color: #aaaaaa;
    cursor: pointer;

    &:not(:first-child) {
        margin-left: calc(100vw * (65 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font: calc(100vw * (14 / 1300)) "Pop-SB";

        &:not(:first-child) {
            margin-left: calc(100vw * (65 / 1300));
        }
    }
    @media screen and (max-width: 900px) {
        font: ${M(13)} "Pop-SB";

        &:not(:first-child) {
            margin-left: ${M(30)};
        }
    }
`;

const InfoBigWrap = styled.div``;

const InfoWrap = styled.article`
    display: flex;
    align-items: center;

    &:first-child {
        margin-bottom: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:first-child {
            margin-bottom: calc(100vw * (10 / 1300));
        }
    }
    @media screen and (max-width: 900px) {
        display: block;

        &:first-child {
            margin-bottom: ${M(3)};
        }

        & > div:not(:first-child) {
            margin-top: ${M(3)};
        }
    }
`;
const InfoMbWrap = styled.div`
    display: flex;
    align-items: center;
    & > div:first-child {
        margin-right: ${M(10)};
    }
`;

const Info = styled.div`
    font: calc(100vw * (14 / 1920)) "Noto-R";
    color: #666666;

    &:not(:first-child) {
        margin-left: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        &:not(:first-child) {
            margin-left: calc(100vw * (20 / 1300));
        }
    }
    @media screen and (max-width: 900px) {
        font-size: ${M(13)};

        &:not(:first-child) {
            margin-left: 0;
        }
    }
`;

const BottomWrap = styled.section`
    padding: calc(100vw * (30 / 1920)) 0;
    background: #000;

    & > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    @media screen and (max-width: 1300px) {
        padding: ${T(30)} 0;
    }
    @media screen and (max-width: 900px) {
        padding: ${M(30)} 0 ${M(55)};

        & > div {
            display: block;
        }
    }
`;

const LeftCon = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(25)};
    }
`;

const CopyRight = styled.p`
    font: calc(100vw * (16 / 1920)) "Noto-M";
    margin-right: calc(100vw * (50 / 1920));
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        font-size: ${T(16)};

        margin-right: ${T(50)};
    }
    @media screen and (max-width: 900px) {
        font-size: ${M(13)};

        margin-right: ${M(45)};
    }
`;

const TermsWrap = styled.ul`
    display: flex;
    align-items: center;
`;

const Terms = styled.li`
    font: calc(100vw * (14 / 1920)) "Noto-M";

    cursor: pointer;
    color: #aaaaaa;

    &:first-child {
        margin-right: calc(100vw * (30 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        &:first-child {
            margin-right: ${T(30)};
        }
    }
    @media screen and (max-width: 900px) {
        font-size: ${M(13)};

        &:first-child {
            margin-right: ${M(20)};
        }
    }
`;

const RightCon = styled.div`
    display: flex;
    align-items: center;
`;

const SnsTitle = styled.p`
    font: calc(100vw * (14 / 1920)) "Pop-M";
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }
    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;

const SnsWrap = styled.ul`
    display: flex;
    align-items: center;
`;

const Sns = styled.li`
    position: relative;
    margin-left: calc(100vw * (10 / 1920));

    width: calc(100vw * (20 / 1920));
    height: calc(100vw * (20 / 1920));
    cursor: pointer;

    @media screen and (max-width: 1300px) {
        margin-left: calc(100vw * (10 / 1300));

        width: calc(100vw * (20 / 1300));
        height: calc(100vw * (20 / 1300));
    }
    @media screen and (max-width: 900px) {
        margin-left: ${M(10)};

        width: ${M(29)};
        height: ${M(29)};
    }
`;

const SnsImg = styled.img`
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
`;
